const LAUNCH_SCRIPTS = {
  staging: 'https://assets.adobedtm.com/75d94c6e0d96/5bfc07d69cba/launch-e9a40c8d4ae6-staging.min.js',
  production: 'https://assets.adobedtm.com/75d94c6e0d96/5bfc07d69cba/launch-8110db95aafb.min.js'
};

const getEnvironment = () => {
  if (typeof process !== 'undefined' && process.env) {
    if (process.env.REACT_APP_ENV) {
      return process.env.REACT_APP_ENV;
    }
    return process.env.NODE_ENV === 'production' ? 'production' : 'staging';
  }
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost' || window.location.hostname.includes('staging')) {
      return 'staging';
    }
  }
  return 'production';
};

export const initAdobeLaunch = () => {
  const env = getEnvironment();
  const scriptUrl = LAUNCH_SCRIPTS[env] || LAUNCH_SCRIPTS.staging;
  
  if (document.querySelector(`script[src="${scriptUrl}"]`)) {
    return;
  }
  
  const script = document.createElement('script');
  script.src = scriptUrl;
  script.async = true;
  document.head.appendChild(script);
  
  console.log(`%c[ANALYTICS] Adobe Launch initialized (${env})`, 'color: green; font-weight: bold');
};

export const pageBottom = () => {
  if (typeof window._satellite !== 'undefined' && window._satellite.pageBottom) {
    window._satellite.pageBottom();
  }
};

